import './assets/css/ekka.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './pages/App';// Add this line for JS
//import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Suppress only the noisy ResizeObserver loop errors without affecting others
if (typeof window !== 'undefined') {
  const resizeObserverErr = /ResizeObserver loop (limit exceeded|completed with undelivered notifications)/i;
  // Capture phase to intercept early
  window.addEventListener('error', (event) => {
    const msg = String(event?.message || '');
    if (resizeObserverErr.test(msg)) {
      event.stopImmediatePropagation();
      event.preventDefault();
    }
  }, true);
  // Some libs surface it via unhandledrejection
  window.addEventListener('unhandledrejection', (event) => {
    const reason = event?.reason;
    const msg = reason && (reason.message || String(reason)) || '';
    if (resizeObserverErr.test(String(msg))) {
      event.preventDefault();
    }
  });
  const originalConsoleError = console.error;
  console.error = function (...args) {
    try {
      if (args && args.length) {
        const first = args[0];
        const msg = typeof first === 'string' ? first : (first && first.message) || '';
        if (resizeObserverErr.test(String(msg))) return;
      }
    } catch {}
    return originalConsoleError.apply(console, args);
  };
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();